import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetSectors } from '@/hooks/useGetSectors';
import { SelectOptions } from '@/components/ui/SelectOptions';
import * as S from './styles';

const { useFormInstance, useWatch } = Form;

interface SectorFormItemProps {
	disabled?: boolean;
}

export function SectorFormItem({ disabled = false }: SectorFormItemProps) {
	const form = useFormInstance();
	const organization_id: string = useWatch('organization_id');
	const company_id: string = useWatch('company_id');

	const sectors = useGetSectors({
		organization_id,
		company_id
	});

	function handleOnChange(): void {
		form.setFieldValue('line_id', undefined);
		form.setFieldValue('workstation_id', undefined);
	}

	const isDisabled: boolean = disabled || !organization_id || !company_id;

	return (
		<S.CustomFormItem name="sector_id" label={I18n.get('Sector')} labelCol={{ span: 24 }}>
			<SelectOptions
				allowClear
				disabled={isDisabled}
				options={sectors.data}
				onChange={disabled ? undefined : handleOnChange}
				loading={sectors.isFetching}
				placeholder={I18n.get('Sector')}
			/>
		</S.CustomFormItem>
	);
}
